<span
  *ngIf="percent || percent === 0"
  class="campaign-detail {{ 'campaign-detail--' + status }}"
>
  {{ percent | percent: '1.0-2' }}
</span>
<ng-content></ng-content>
